import { useEffect, useState } from "react";
import { Form, Tree } from "antd";

import { recordError } from "src/utils/logService";
import service from 'src/services/citizenScienceService';

const TargetBeneficiaries = ({ formRef, data }) => {

  const [checkedKeys, setCheckedKeys] = useState(data.beneficiaries);
  const [beneficiariesTData, setBeneficiariesTData] = useState([]);

  var beneficiaryErrorMsg = "Please select at least one beneficiary option/sub-option";

  const [form] = Form.useForm();

  useEffect(() => {
    if (formRef != null) {
      formRef.current = form;
    }
    getTargetBeneficieries();
  }, [form, formRef]);

  const onCheck = (checkedKeysValue) => {
    if (checkedKeysValue[0] === "other") {
    }

    setCheckedKeys(checkedKeysValue);
    form.setFieldsValue({ tree: checkedKeysValue });

    if (checkedKeysValue.length > 0) {
      form.setFields([
        {
          name: "beneficiary",
          value: checkedKeysValue,
          errors: [],
        },
      ]);
    } else {
      form.setFields([
        {
          name: "beneficiary",
          value: [],
          errors: [beneficiaryErrorMsg],
        },
      ]);
    }
  };
  
  const getTargetBeneficieries = async () => {
    try {
      const response = await service.getTargetBeneficieries(true);

      if (response && response.status === 200) {
        const { data } = response;
        const treeData = data.map((b) => {
          return {
            key: b.key, title: b.value,
            children: b.children?.map((c) => {
              return {
                key: c.key,
                title: c.value
              }
            })
          }
        })
        setBeneficiariesTData(treeData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  return (
    <>
      {
        beneficiariesTData.length &&
        <Tree
          defaultExpandAll={true}
          treeData={beneficiariesTData}
          checkable
          onCheck={onCheck}
          checkedKeys={checkedKeys}
          disabled={true}
        />
      }
    </>
  );
};

export default TargetBeneficiaries;
